/* eslint-disable object-shorthand */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import Handler from "./Modules/Handler";
import Table from "./Modules/Table";
import { useStore } from "../../store";
import { Wrap } from "./styles";
import Title from "../../components/Title";
import { useDidMountEffect } from "../../utils/custom";
import { useCookies, Cookies } from "react-cookie";
import moment from "moment";
import dayjs from "dayjs";
import { defaultAllCode } from "./LanguageCode";
import useKeyPress from "../../utils/custom/useKeyPress";
import { TemplatesRequestProps } from "../../api/types";
import { getTemplates } from "../../api/Templates";
import {
  setStartFormat,
  setEndFormat,
} from "../../utils/dateformat/dateFormat";
import { getItem } from "../../utils/nauth";
import SnackBar from "../../components/SnackBar/SnackBar";
import { defaultAllCategory } from "./CategoryCode";

const UploadedList = () => {
  const {
    TemplatesStore: {
      application,
      status,
      startDate,
      endDate,
      searchOption,
      language,
      category,
      setRows,
      setSearchText,
      setSearchOption,
      searchHandler,
      setApplication,
      setStatus,
      setStartDate,
      setEndDate,
      gridOption: { page, rowsPerPage, loading, sort, totalCount },
      setGridOption,
      onPageChange,
      setLanguageChange,
      setCategoryChange,
      mixability,
      reference,
      asset,
      entertainment,
      searchText,
      ratio,
      isBlind,
    },
  } = useStore();

  const [msgSB, setMsgSB] = useState("");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const userRole = getItem("role");
  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };
  const [userIdStatus, setUserIdStatus] = useState<boolean>(false);
  const gCookie = new Cookies();
  const getCookie = (item: string) => {
    return gCookie.get(item);
  };

  useDidMountEffect(() => {
    if (pathname.includes("userid") && !userIdStatus) {
      setUserIdStatus(true);
      const array = pathname.split("/");
      const userid = array[array.length - 1];

      setGridOption({
        page: 0,
      });
      setLanguageChange(defaultAllCode);

      setStartDate(dayjs().subtract(1, "month").toDate());

      if (userid !== "") {
        removeCookie("page", { path: "/" });
        removeCookie("startDate", { path: "/" });
        removeCookie("status", { path: "/" });
        removeCookie("application", { path: "/" });

        setSearchOption("userId");
        setSearchText(userid);
        setStatus("All");
      }
    }

    setRows();
  }, [page, rowsPerPage, pathname]);

  useEffect(() => {
    if (pathname.includes("userid") && !userIdStatus) {
      setUserIdStatus(true);
      const array = pathname.split("/");
      const userid = array[array.length - 1];

      setGridOption({
        page: 0,
      });
      setLanguageChange(defaultAllCode);

      setStartDate(dayjs().subtract(1, "month").toDate());

      if (userid !== "") {
        removeCookie("page", { path: "/" });
        removeCookie("startDate", { path: "/" });
        removeCookie("status", { path: "/" });
        removeCookie("application", { path: "/" });

        setSearchOption("userId");
        setSearchText(userid);
        setStatus("All");
      }
    }
    setRows();
  }, []);

  const handleKeyDown = async (event: KeyboardEvent) => {
    if (!isUserRole()) return;

    let element: HTMLElement = event.target as HTMLElement;
    if (element) {
      if (element.querySelector("div")?.id !== "openedDlg") {
        switch (element.tagName) {
          case "INPUT":
          case "LI":
          case "TEXTAREA":
          case "BUTTON":
            break;
          default:
            if (event.key === "ArrowRight") {
              const pageCount = Math.ceil(totalCount / rowsPerPage);
              if (pageCount > page + 1) {
                onPageChange(page + 1);
                event.preventDefault();
              }
            } else if (event.key === "ArrowLeft" && page >= 1) {
              onPageChange(page - 1);
              event.preventDefault();
            } else if (event.key === "g") {
              event.preventDefault();
              let templateID: string = "";
              let temp: any;

              const requestParameter: TemplatesRequestProps = {
                page: 1,
                display: 100,
                startedAt: setStartFormat(new Date(2023, 4, 1)),
                endedAt: setEndFormat(new Date()),
                reviewStatus: "InReview",
                language: getCookie("language")
                  ? getCookie("language").value
                  : defaultAllCode.value,
                sort: "asc",
              };

              await getTemplates(requestParameter)
                .then((data) => {
                  data.templates.some((template: any) => {
                    if (template !== undefined) {
                      if (template.reviewer === "") {
                        templateID = template.templateId;
                        temp = template;
                        return true;
                      }
                    }
                    return false;
                  });
                  if (templateID.length && temp) {
                    navigate(`/templates/${templateID}`, {
                      state: {
                        template: temp,
                      },
                    });
                  } else {
                    setMsgSB("There are no empty reviewers for 100 templates.");
                  }
                })
                .catch((err) => {
                  console.error(err);
                  setMsgSB("getTemplates return Error");
                });
            }
            break;
        }
      }
    }
  };

  useKeyPress(["ArrowRight", "ArrowLeft", "g"], handleKeyDown);

  return (
    <Wrap>
      <Title label="Templates" isDivider />
      <Handler />
      <Table />
      {msgSB !== "" && <SnackBar msg={msgSB} setMsg={setMsgSB} />}
    </Wrap>
  );
};

export default observer(UploadedList);
